/**
 * GlobalHook - Generic global behaviors for LiveView pages.
 *
 * Features:
 * - Clear stale scroll locks after LiveView events
 */
export const GlobalHook = {
  mounted() {
    this.handleEvent("unlock-scroll", () => {
      const dialogs = document.querySelectorAll("div[role='dialog']");
      const hasOpenDialog = Array.from(dialogs).some(
        (dialog) => dialog.offsetParent !== null,
      );

      if (hasOpenDialog) {
        return;
      }

      document.body.classList.remove("overflow-hidden");
      document.body.style.removeProperty("overflow");
      document.documentElement.style.removeProperty("overflow");
    });
  },
};
